
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0f35f5f2!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FilterValue.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./FilterValue.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-0f35f5f2!../../node_modules/vue-loader/lib/selector?type=template&index=0!./FilterValue.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/FilterValue.vue
// module id = 191
// module chunks = 2